import { KnownProgramCounter } from './KnownProgramCounter';
import { LastProgramCounter } from './LastProgramCounter';
export class ProgramCounterHelper {
    constructor(pc) {
        this.pc = pc;
        this.first = new KnownProgramCounter(this.pc());
        this.last = new LastProgramCounter(this.pc());
    }
    getFirst() {
        return this.first;
    }
    getCurrent() {
        return new KnownProgramCounter(this.pc());
    }
    getLast() {
        return this.last;
    }
    setLast() {
        this.last.setPC(this.pc());
    }
}

//# sourceMappingURL=ProgramCounterHelper.js.map
